import useSourceFlowCollection from "@/hooks/useSourceFlowCollection";
import data from "@sourceflow/sector_roles.json";

export const useSectorRoles = () => {
  // const rawData = useSourceFlowCollection(data);
  //
  // const uniqueData = Array.from(new Set(rawData.map((item) => item.role))).map((role) =>
  //   rawData.find((item) => item.role === role),
  // );
  //
  // return uniqueData;
  return useSourceFlowCollection(data);
};

export default useSectorRoles;
